import { render, staticRenderFns } from "./teachingCat.vue?vue&type=template&id=1b793766&scoped=true&"
import script from "./teachingCat.vue?vue&type=script&lang=js&"
export * from "./teachingCat.vue?vue&type=script&lang=js&"
import style0 from "./teachingCat.vue?vue&type=style&index=0&id=1b793766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b793766",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
